import { render, staticRenderFns } from "./InventoryItemViewModal.vue?vue&type=template&id=1131b3de"
import script from "./InventoryItemViewModal.vue?vue&type=script&lang=ts"
export * from "./InventoryItemViewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports